import React from "react";
import MaterialsRow from "./MaterialsRow";
import { useLang } from "~/hooks/useLang";
import type { ItemMaterialCheckout } from "../../interface";
import { none, useHookstate, type State } from "@hookstate/core";
import { Avatar, Button, Grid, IconButton, Typography } from "@mui/material";
import { Add } from "@mui/icons-material";

interface MaterialsCheckoutProps {
  readonly warehouseId: State<number | null>;
  readonly materialsItens: State<ItemMaterialCheckout[]>;
}

const itemDefaultValue: ItemMaterialCheckout = {
  itemId: null,
  groupId: null,
  quantity: null,
  material: null
}

export default function MaterialsCheckout({ warehouseId, materialsItens }: MaterialsCheckoutProps) {
  const { translate } = useLang();
  const addItem = () => materialsItens.merge([itemDefaultValue])

  const removeItem = (index: number) => materialsItens[index].set(none)
  return (
    <>
      <Grid container direction="row" justifyContent="flex-start" alignItems="center" gap={2} marginBottom={2}>
        <Typography variant="h6" >
          {translate('Materials')}
        </Typography>
        <Avatar
          onClick={addItem}
          sx={{
            width: 24,
            height: 24,
            cursor: 'pointer',
            backgroundColor: 'primary.main'
          }}
        >
          <Add />
        </Avatar>
      </Grid>
      {materialsItens.map((item, index) => (
        <Grid key={index} container xs={12} spacing={2} marginBottom={2}>
          <MaterialsRow
            item={item}
            position={index}
            warehouseId={warehouseId}
            disabledRemoveItem={materialsItens.length >= 1}
            onRemove={() => removeItem(index)}
          />
        </Grid>
      ))}
    </>
  )
}